import { useEffect, useRef, useState } from 'react';

/** QR local do copia-e-cola. Não chama serviço externo. */
export function PixQr({ value }: { value: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setFailed(false);
    import('qr-code-styling')
      .then(({ default: QRCode }) => {
        const el = ref.current;
        if (cancelled || !el) return;
        const qr = new QRCode({
          type: 'svg',
          width: 220,
          height: 220,
          margin: 8,
          data: value,
          qrOptions: { errorCorrectionLevel: 'M' },
          backgroundOptions: { color: '#ffffff' },
          dotsOptions: { color: '#111111' },
        });
        el.replaceChildren();
        qr.append(el);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [value]);

  if (failed) return <p className="text-sm text-muted-foreground">Não foi possível desenhar o QR. Use o copia-e-cola.</p>;
  return <div ref={ref} className="mx-auto w-[220px] overflow-hidden rounded-xl bg-white p-2" />;
}
